/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ResourceDraft } from './ResourceDraft';

export const ListDraft: core.serialization.ObjectSchema<serializers.ListDraft.Raw, Truvity.ListDraft> =
    core.serialization.object({
        items: core.serialization.list(ResourceDraft),
    });

export declare namespace ListDraft {
    export interface Raw {
        items: ResourceDraft.Raw[];
    }
}
